import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createCallOutbound } from '../../../../api/outbound/pokerOutbounds';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
import { getShortRenderedValueStr } from '../../../../utils/numberPrecisionUtils';
import { Button } from '../../pixiComponents/button';
export const PixiCallButton = ({ bounds, myTurnProperties }) => {
    const socketSend = useSocketSend();
    const onClickCall = useCallback(() => {
        socketSend(createCallOutbound(myTurnProperties.betSequenceNumber));
    }, [myTurnProperties, socketSend]);
    const additionalChipsToCall = myTurnProperties.betTotalAmountToCall - myTurnProperties.myTotalBetAmount;
    const isAllInToCall = myTurnProperties.myNumChips <= additionalChipsToCall;
    const actionLabel = isAllInToCall ? 'ALL-IN' : 'CALL';
    const subLabel = isAllInToCall
        ? getShortRenderedValueStr(myTurnProperties.myNumChips)
        : getShortRenderedValueStr(additionalChipsToCall);
    return (_jsx(Button, { pixiObjectData: { type: 'call-button' }, onClick: onClickCall, labelProperties: {
            label: actionLabel,
            bitmapTextStyleType: 'button-label',
            labelPixiDataType: 'call-button-label'
        }, subLabelProperties: {
            label: subLabel,
            bitmapTextStyleType: 'button-sub-label',
            labelPixiDataType: 'call-button-sub-label'
        }, bounds: bounds, accentColor: 'blue' }));
};
